import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function boxed_tabbed_docs({ attributes, docSections, multiDocs, articlesNumber }) {
    const { col, readMoreText, docs_layout, sectionsNumber, orderBy, child_docs_order } = attributes;

    // State for active tab
    const [activeTab, setActiveTab] = useState(null);

    // Fetch all documents (both parents and children)
    const allDocs = useSelect(
        (select) =>
            select("core").getEntityRecords("postType", "docs", {
                per_page: -1, // Fetch all documents
                status: ["publish", "private"],
                order: child_docs_order, // Specify order: 'asc' or 'desc'
                orderby: orderBy, // Specify field to order by, e.g., 'menu_order', 'date', 'title'
            }),
        [child_docs_order, orderBy]
    );

    useEffect(() => {
        if (docSections && docSections.length > 0) {
            // Set the first section as the default active tab
            setActiveTab(docSections[0].id);
        } else if (multiDocs && multiDocs.length > 0) {
            // Set the first multiDoc as the default active tab if docSections is empty
            setActiveTab(multiDocs[0].id);
        }
    }, [docSections, multiDocs]);

    if (!allDocs) return <p>Loading...</p>;
    if (allDocs.length === 0) return <p>No documents found.</p>;

    // Separate parent and child documents
    const mainDocs = allDocs.filter((doc) => doc.parent === 0); // Parent docs are those with parent === 0
    const getChildDocs = (parentId) => allDocs.filter((doc) => doc.parent === parentId);
    // Children are filtered by parentId
        
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col} topic_list_inner` : `ezd-masonry-wrap ezd-masonry-col-${col} topic_list_inner`;

    return (
        <div className="question_menu docs3" id="Arrow_slides-bada9fe">
            <div className="tabs_sliders">
                <span className="scroller-btn left inactive">
                    <i className="arrow_carrot-left"></i>
                </span>

                <ul className="nav nav-tabs mb-5 ezd-tab-menu slide_nav_tabs">
                    {(docSections || multiDocs) &&
                        [...(docSections || []), ...(multiDocs || [])].map((section) => {
                            const { id, title, slug } = section;

                            return (
                                <li className="nav-item" key={id}>
                                    <a
                                        data-rel={slug}
                                        className={`nav-link ezd_tab_title ${
                                            activeTab === id ? "active" : ""
                                        }`}
                                        onClick={() => setActiveTab(id)}
                                    >
                                        {title.rendered}
                                    </a>
                                </li>
                            );
                        })}
                </ul>

                <span className="scroller-btn right inactive">
                    <i className="arrow_carrot-right"></i>
                </span>
            </div>

            {(docSections || multiDocs) &&
                [...(docSections || []), ...(multiDocs || [])].map((section) => {
                    // Get child docs for this section
                    const childDocs = getChildDocs(section.id).slice(0, sectionsNumber);

                    return (
                        <div
                            className={`doc_tab_pane ezd-tab-box ${
                                activeTab === section.id ? "active" : ""
                            }`}
                            id={section.slug} key={section.id}
                        >
                            <div className={layoutType}>
                                {childDocs.length > 0 ? (
                                    childDocs.slice(0, sectionsNumber).map((childDoc) => (

                                        <div className="topic_list_item" key={childDoc.id}>
                                        <h4 className="ezd_item_title">{childDoc.title.rendered}</h4>
                                        <ul className="navbar-nav">
                                            {/* Get child documents where parent ID matches childDoc.id */}
                                            {allDocs.filter((doc) => doc.parent === childDoc.id).slice(0, articlesNumber).map((nestedChild) => (
                                                <li key={nestedChild.id}>
                                                    <a href={nestedChild.link} className="ezd_item_list_title">
                                                        {nestedChild.title.rendered}
                                                    </a>
                                                </li>
                                                ))
                                            }
                                        </ul>
                                        <a href={childDoc.link} className="text_btn dark_btn ezd_btn">
                                            {readMoreText || "View All"} <i className="arrow_right"></i>
                                        </a>
                                    </div>
                                    ))
                                ) : (
                                    <div class="topic_list_item">
                                        <h4 class="ezd_item_title">No child documents found for this section. </h4>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}
